import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './app/redux/store';
import App from './app/app';
import * as ReactRouterDom from 'react-router-dom';

export * from '@gvp-microapps/gvp-core/public-api'
const BrowserRouter: any = ReactRouterDom.BrowserRouter

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);
